import FormPageLayout from './FormPageLayout.jsx';

export default FormPageLayout;
